import shop from '../../api/customize'

// initial state
const state = {
  all: {}
}

// getters
const getters = {
  finished: state => {
    let result = (state.all.sections.find(tmp => tmp.selected.length === 0) == null) && state.all.name !== '' && state.all.quantity > 0
    return result
  }
}

// actions
const actions = {
  getAllCusmoizes ({ commit }) {
    shop.getCusmoizes(customizes => {
      commit('setCusmoizes', customizes)
    })
  },
  itemSelect ({ state, commit }, item) {
    const tmpItem = state.all.sections.find(tmp => tmp.id === item.parentid)
    if (tmpItem != null) {
      commit('setSelectedItem', item)
    }
  },
  changeQuantity ({ state, commit }, status) {
    commit('changeQuantity', status)
  },
  changeName ({ state, commit }, input) {
    commit('setName', input.target.value)
  }
}

// mutations
const mutations = {
  setCusmoizes (state, customizes) {
    state.all = customizes
  },
  setSelectedItem (state, item) {
    const section = state.all.sections.find(tmp => tmp.id === item.parentid)
    if (section != null) {
      if (item.icon === '') {
        section.selected = [item.id]
      } else {
        let nonItem = section.items.find(tmp => tmp.icon === '')
        if (nonItem != null && item.id !== nonItem.id) {
          let nonIndex = section.selected.indexOf(nonItem.id)
          if (nonIndex > -1) {
            section.selected.splice(nonIndex, 1)
          }
        }
        if (section.multi > 0) {
          let index = section.selected.indexOf(item.id)
          if (index > -1) {
            section.selected.splice(index, 1)
          } else {
            if (section.selected.length >= section.multi) {
              section.selected.splice(0, 1)
            }
            section.selected.push(item.id)
          }
        } else if (section.multi === 0) {
          let index = section.selected.indexOf(item.id)
          if (index > -1) {
            section.selected.splice(index, 1)
          } else {
            section.selected.push(item.id)
          }
        }
      }
    }
  },
  changeQuantity (state, status) {
    if (status > 0) {
      state.all.quantity += 1
    } else {
      if (state.all.quantity === 1) {
        state.all.quantity = 1
      } else {
        state.all.quantity -= 1
      }
    }
  },
  setName (state, newValue) {
    state.all.name = newValue
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/customize.js